import { shipmentPtlIndexEntity } from "../domain/entities/shipment_ptl_index_entity";
import { shipmentPtlShowEntity } from "../domain/entities/shipment_ptl_show_entity";
import { ptlProductEntity } from "../../products/domain/entities/ptl_product_entity";
import { shipmentIndexEntity } from "../domain/entities/shipment_index_entity";
import { shipmentPtlAssembleEntity } from "../domain/entities/shipment_ptl_assemble_entity";
import { ShipmentAffEntity } from "../domain/entities/shipment_aff_entity";
import { ShipmentAffPrepareEntity } from "../domain/entities/shipment_aff_prepare_entity";
import { ShipmentAffScannedEntity } from "../domain/entities/shipment_aff_scanned_entity";
import { ShipmentAffProductsByOrderEntity } from "../domain/entities/shipment_aff_get_products_by_order_entity";
import { shipmentShowEntity } from "../domain/entities/shipment_show_entity";
import { ShipmentContract } from "../domain/contracts/shipment_contract";
import { ShipmentShippingServicesEntity } from "../domain/entities/shipment_shipping_services_entity";

import http from "../../../plugins/http-common"
import i18n from "../../../i18n";

export const HttpShipmentRepository = {
    ...ShipmentContract,
    model_ptl_index: shipmentPtlIndexEntity,
    model_ptl_show: shipmentPtlShowEntity,
    model_ptl_product: ptlProductEntity,
    model_ptl_assemble: shipmentPtlAssembleEntity,
    model_index: shipmentIndexEntity,
    model_show: shipmentShowEntity,
    model_aff_index: ShipmentAffEntity,
    model_aff_prepare: ShipmentAffPrepareEntity,
    model_aff_scanned: ShipmentAffScannedEntity,
    model_aff_products_by_order: ShipmentAffProductsByOrderEntity,
    model_shipping_services: ShipmentShippingServicesEntity,
    actions: [{
        name: i18n.t('fulfillment_ptl_pendings.details'),
        icon: {
            color: 'accent',
            icon: 'info'
        },
        method: 'showDetails',
    },
    {
        name: i18n.t('fulfillment_ptl_pendings.edit'),
        icon: {
            color: 'accent',
            icon: 'edit'
        },
        method: 'redirectEdit',
    },
    {
        name: i18n.t('fulfillment_ptl_pendings.delete'),
        icon: {
            color: 'accent',
            icon: 'delete'
        },
        method: 'askDelete',
    },
    {
        name: i18n.t('fulfillment_ptl_pendings.prepare'),
        icon: {
            color: 'accent',
            icon: 'send'
        },
        method: 'prepareSingleOrder',
    },
    {
        name: i18n.t('fulfillment_ptl_supplied.restore'),
        icon: {
            color: 'accent',
            icon: 'history'
        },
        method: 'askRestore',
    }],
    
    async ptl_get_orders_pendings(shipping_service) {
        const res = await http.get('fulfillment_ptl/pending_orders?shipping_service=' + shipping_service + '&shipment_type=shipments');

        return res.data.success.arguments.map(item => ({
            ...item,
            actions: JSON.parse(JSON.stringify(this.actions.slice(0, 4))),
            parameters: item
        }));
    },
    
    async ptl_get_confirmed_orders(shipping_service) {
        const res = await http.get('fulfillment_ptl/confirmed_orders?shipping_service=' + shipping_service + '&shipment_type=shipments');

        return res.data.success.arguments.map(item => ({
            ...item,
            actions: JSON.parse(JSON.stringify(this.actions.slice(0, -4))),
            parameters: item
        }));
    },
    
    async ptl_get_supplied_orders(shipping_service) {
        const res = await http.get('fulfillment_ptl/supplied_orders?shipping_service=' + shipping_service + '&shipment_type=shipments');

        return res.data.success.arguments.map(item => ({
            ...item,
            prepared: item.last_status == "FULFILLED" ? false : true,
            actions: JSON.parse(JSON.stringify(this.actions.slice(0, 1).concat(this.actions.slice(-1)))),
            parameters: item
        }));
    },
    
    async ptl_get_sent_orders(shipping_service) {
        const res = await http.get('fulfillment_ptl/sent_orders?shipping_service=' + shipping_service + '&shipment_type=shipments');

        console.log(this.actions.slice(0, 3).concat(this.actions.slice(-1)));
        return res.data.success.arguments.map(item => ({
            ...item,
            actions: JSON.parse(JSON.stringify(this.actions.slice(0, 1).concat(this.actions.slice(-1)))),
            parameters: item
        }));
    },
    
    async ptl_get_returned_orders(shipping_service) {
        const res = await http.get('fulfillment_ptl/returned_orders?shipping_service=' + shipping_service + '&shipment_type=shipments');

        return res.data.success.arguments.map(item => ({
            ...item,
            actions: JSON.parse(JSON.stringify(this.actions.slice(0, 1).concat(this.actions.slice(-1)))),
            parameters: item
        }));
    },
    
    async ptl_show_order_info(id) {
        const res = await http.get('fulfillment_ptl/get_order_info?id=' + id.toString() + '&shipment_type=shipments');

        return res;
    },
    
    async ptl_delete_order(id) {
        const res = await http.delete('fulfillment_ptl/delete_order?id=' + id.toString() + '&shipment_type=shipments');

        return res;
    },
    
    async ptl_prepare_orders(order_ids) {
        const res = await http.post('fulfillment_ptl/prepare_orders?shipment_type=shipments', order_ids);

        return res;
    },
    
    async ptl_release_orders(trace_id) {
        const res = await http.delete('fulfillment_ptl/release_orders/' + trace_id + '?shipment_type=shipments')

        return res;
    },
    
    async ptl_confirm_orders(trace_id) {
        const res = await http.put('fulfillment_ptl/confirm_orders/' + trace_id + '?shipment_type=shipments')

        return res;
    },
    
    async ptl_get_order_by_tote(tote) {
        const res = await http.get('fulfillment_ptl/shipment_by_tote/' + tote)

        return res;
    },

    async ptl_get_label(data) {
        const res = await http.post('fulfillment_ptl/generate_label?shipment_type=shipments', data);

        return res;
    },

    async index(url, page, per_page, search, shipping_service, cod, sort_by) {
        var sort = ""

        if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;
        const res = await http.get('shipment/' + url + '?shipping_service=' + shipping_service + '&cod=' + cod + '&page=' + page + '&per_page=' + per_page + (search != "" ? '&search=' + search : "") + sort);

        return res;       
    },

    async show(id) {
        const res = await http.get(`shipment/getOrderInformation/${id}`);

        return res;
    },

    // ADVANCED FULFILLMENT
    async get_aff_index_orders(status, page, per_page, search, sort_by, shipping_service) {
        var sort = ""
        if (sort_by.length > 0) sort = `&sort=${sort_by[0].field}&sort_direction=${sort_by[0].direction}`;
        const res = await http.get(`v1/advanced_fulfillment/${status}?shipping_service=${shipping_service}&page=${page}&per_page=${per_page}&search=${search}${sort}`)

        return res;
    },

    async aff_prepare_orders(ids) {
        const res = await http.post('v2/advanced-fulfillment/prepare-orders', { shipments: ids });
        
        return res;
    },

    async aff_scan_identifier(transaction_id, identifier){
        const res = await http.post(`v2/advanced-fulfillment/picking/${transaction_id}/scan`, { identifier: identifier });

        return res;
    },

    async aff_get_current_session(transaction_id) {
        const res = await http.get(`v2/advanced-fulfillment/${transaction_id}`);

        return res;
    },

    async aff_get_products_by_order(id) {
        const res = await http.get(`v1/advanced_fulfillment/products_by_shipment/${id}`);

        return res;
    },

    async get_ff_shipping_services(shipping_service) {
        const res = await http.get(`shipping-service/available-services?shipping_service=${shipping_service.toUpperCase()}`);

        return res;
    },
};